// Sample property database
export const properties = [
  {
    id: 1,
    title: "Modern Downtown Condo",
    location: "Downtown",
    price: 450000,
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1200,
    type: "Condo",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800",
    description: "Luxury condo in the heart of downtown with stunning city views."
  },
  {
    id: 2,
    title: "Spacious Family Home",
    location: "Suburbs",
    price: 650000,
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2500,
    type: "House",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800",
    description: "Beautiful family home with large backyard and modern amenities."
  },
  {
    id: 3,
    title: "Cozy Studio Apartment",
    location: "Midtown",
    price: 250000,
    bedrooms: 1,
    bathrooms: 1,
    sqft: 600,
    type: "Apartment",
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800",
    description: "Perfect starter home in a vibrant neighborhood."
  },
  {
    id: 4,
    title: "Luxury Penthouse",
    location: "Downtown",
    price: 1200000,
    bedrooms: 3,
    bathrooms: 3,
    sqft: 2000,
    type: "Condo",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800",
    description: "Exclusive penthouse with panoramic views and premium finishes."
  },
  {
    id: 5,
    title: "Charming Townhouse",
    location: "Uptown",
    price: 550000,
    bedrooms: 3,
    bathrooms: 2.5,
    sqft: 1800,
    type: "Townhouse",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800",
    description: "Renovated townhouse with modern kitchen and private patio."
  },
  {
    id: 6,
    title: "Beachfront Villa",
    location: "Coastal",
    price: 1500000,
    bedrooms: 5,
    bathrooms: 4,
    sqft: 3500,
    type: "House",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800",
    description: "Stunning beachfront property with private beach access."
  },
  {
    id: 7,
    title: "Urban Loft",
    location: "Midtown",
    price: 380000,
    bedrooms: 1,
    bathrooms: 1,
    sqft: 900,
    type: "Apartment",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800",
    description: "Industrial-style loft with high ceilings and exposed brick."
  },
  {
    id: 8,
    title: "Suburban Ranch",
    location: "Suburbs",
    price: 480000,
    bedrooms: 3,
    bathrooms: 2,
    sqft: 1600,
    type: "House",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800",
    description: "Single-level ranch home with spacious yard and updated interior."
  },
  {
    id: 9,
    title: "Downtown Studio",
    location: "Downtown",
    price: 220000,
    bedrooms: 1,
    bathrooms: 1,
    sqft: 500,
    type: "Apartment",
    image: "https://images.unsplash.com/photo-1536376072261-38c75010e6c9?w=800",
    description: "Efficient studio in prime location, perfect for young professionals."
  },
  {
    id: 10,
    title: "Mountain Retreat",
    location: "Mountains",
    price: 850000,
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2800,
    type: "House",
    image: "https://images.unsplash.com/photo-1542718610-a1d656d1884c?w=800",
    description: "Secluded mountain home with breathtaking views and modern design."
  },
  {
    id: 11,
    title: "Historic Brownstone",
    location: "Uptown",
    price: 920000,
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2400,
    type: "Townhouse",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800",
    description: "Beautifully restored brownstone with original architectural details."
  },
  {
    id: 12,
    title: "Contemporary Condo",
    location: "Midtown",
    price: 520000,
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1100,
    type: "Condo",
    image: "https://images.unsplash.com/photo-1567496898669-ee935f5f647a?w=800",
    description: "Sleek modern condo with floor-to-ceiling windows and city views."
  }
];

